import { http } from "./http";
import type {
  N1coPaymentLinkRequest,
  N1coPaymentLinkResponse,
} from "../types/n1co.types";

export class N1coLinkService {
  public static async createLink(data: N1coPaymentLinkRequest) {
    try {
      const r = await http.post<N1coPaymentLinkResponse>(
        "/PaymentLinks",
        data,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return r.data;
    } catch (err: unknown) {
      console.error(
        "createLink error response:",
        (err as Error)?.message || err
      );
      throw err;
    }
  }
}
